import { render, staticRenderFns } from "./AdminSliderWholesale.vue?vue&type=template&id=b4d4495e&scoped=true&"
import script from "./AdminSliderWholesale.vue?vue&type=script&lang=js&"
export * from "./AdminSliderWholesale.vue?vue&type=script&lang=js&"
import style0 from "./AdminSliderWholesale.vue?vue&type=style&index=0&id=b4d4495e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4d4495e",
  null
  
)

export default component.exports